import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DemoComponent } from "./components/demo/demo.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxImgZoomModule } from "ngx-img-zoom";
import { MainComponent } from "./components/main/main.component";
import { AppRoutingModule } from "./app-routing.module";
import { ShopModule } from "./components/shop/shop.module";
import { SharedModule } from "./components/shared/shared.module";
import { RecoveryPasswdComponent } from "./pages/recovery-passwd/recovery-passwd.component";
import { MainV2Component } from "./components/main-v2/main-v2.component";

@NgModule({
  declarations: [
    AppComponent,
    DemoComponent,
    MainComponent,
    MainV2Component,
    RecoveryPasswdComponent,
  ],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    SharedModule,
    ShopModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgxImgZoomModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
